import { Operation, BaseQueryOptions } from '@apollo/client';

export enum J1GraphQLOperationSource {
  GraphQLProxy,
  ComplianceV2,
}

const OPERATION_TARGETS_COMPLIANCE_V2_KEY = 'operationTargetsComplianceV2';

export const getOperationSource = (
  operation: Operation
): J1GraphQLOperationSource => {
  if (operation.getContext()[OPERATION_TARGETS_COMPLIANCE_V2_KEY]) {
    return J1GraphQLOperationSource.ComplianceV2;
  }

  return J1GraphQLOperationSource.GraphQLProxy;
};

// Type casts here are not ideal, but we're reaching the limits of what
// typescript can infer: https://stackoverflow.com/questions/60735375
export const hydrateApolloOptionsWithOperationSource = (
  operationSource: J1GraphQLOperationSource
) => <T extends Pick<BaseQueryOptions, 'context'>>(
  baseOptions?: T & Pick<BaseQueryOptions, 'context'>
): T =>
  ({
    ...baseOptions,
    context: {
      ...baseOptions?.context,
      [OPERATION_TARGETS_COMPLIANCE_V2_KEY]:
        operationSource === J1GraphQLOperationSource.ComplianceV2,
    } as Pick<T, 'context'>,
  } as T);
